import { useState } from 'react';
import { Box, Divider } from '@mui/material';
import Repeater from 'src/components/repeater/Repeater';
import ContactsForm from './contactsForm';
import useVendorBooth from 'src/hooks/useVendorBooth';
import ConfirmationDialog from '../controls/ConfirmationDialog';

const VendorBoothContact = () => {
  const { vendorBooth, addNewContact, updateContact, deleteContact } = useVendorBooth();
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [currentContactIndex, setCurrentContactIndex] = useState<number>(0); // eslint-disable-line no-unused-vars

  const openDeleteConfirmation = (i) => {
    setDeleteConfirmationOpen(true);
    setCurrentContactIndex(i);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <h3>Contacts</h3>
      <h4>As customers shop the BFG Virtual Show, they can send direct questions to our supplier partners. Add your contact information and start building those relationships today!</h4>
      <Divider />
      <Repeater
        data={vendorBooth.boothContacts}
        onUpdateData={updateContact}
        addNewItem={addNewContact}
        onDeleteItem={openDeleteConfirmation}
        titleField="fullName"
        Form={<ContactsForm />}
      ></Repeater>

      {vendorBooth?.boothContacts != null && vendorBooth.boothContacts[currentContactIndex] && (
        <ConfirmationDialog
          title="Delete Contact"
          open={deleteConfirmationOpen}
          children={
            <p>
              Are you sure you want to delete this contact <strong>{vendorBooth.boothContacts[currentContactIndex].fullName}</strong>?
            </p>
          }
          onClose={(confirmed) => {
            setDeleteConfirmationOpen(false);

            if (!confirmed) {
              return;
            }

            return deleteContact(currentContactIndex);
          }}
        />
      )}
    </Box>
  );
};

export default VendorBoothContact;
